import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import { PageHeader } from 'components/page-header'
import AvailabilityTab from './availability-tab'
import { makeStyles } from '@material-ui/styles'
import { usePortal } from 'lib/portal'

export const useStyles = makeStyles(theme => ({
  customRoot: {
    margin: theme.spacing(7),
    marginTop: theme.spacing(3),
    [theme.breakpoints.only('xs')]: {
      margin: '8px 16px 96px 16px',
    },
  },
}))

const AvailabilityPage = () => {
  const classes = useStyles()
  const { path } = useRouteMatch()
  const [HeaderActionsPortal, headerActionsTarget] = usePortal()

  const crumbs = [
    {
      label: 'Settings',
      to: path
        .split('/')
        .slice(0, 3)
        .join('/'),
    },
  ]

  return (
    <>
      <PageHeader
        title="Availability Settings"
        crumbs={crumbs}
        actions={headerActionsTarget}
      />
      <Box className={classes.customRoot}>
        <AvailabilityTab HeaderActionsPortal={HeaderActionsPortal} />
      </Box>
    </>
  )
}

export default AvailabilityPage
